import MakeOffer, {
    getMakeOfferServerSideProps,
} from '@pb/apps/offers/pages/sales/make-offer';

export default MakeOffer;

export const getServerSideProps = getMakeOfferServerSideProps;
